export default {
    baseUrl: '/',
    appTitle: '爱绩效平台',
};
